<template>
  <WorkInstructionPublisher />
</template>
<script>
import WorkInstructionPublisher from '../Publisher/WorkInstructions';

export default {
  components: { WorkInstructionPublisher },
  name: 'WorkInstructions',
};
</script>
